export default "__VITE_ASSET__CWPmjXgN__"